module.exports = __webpack_public_path__ + "media/images/ic_local-b0240ce7.svg";